<template>
  <el-dialog
    :title="$t('after-sales::after-sale-list::select_order')"
    bodyHeight="550px"
    width="800px"
    :visible.sync="visiable"
    :close-on-click-modal="false"
  >
    <div>
      <z-search v-model="searchForm" :configs="configs" :showReset="false" @do-query="getList"></z-search>
      <z-table
        :data="tableData"
        :columns="columns"
        v-loading="loading"
        height="380px"
        :pagination.sync="pagination"
        @page-change="getList"
      >
        <template #selection="{row}">
          <el-checkbox :value="row.orderNo === orderNo" @change="selectRow(row)"></el-checkbox>
        </template>
      </z-table>
    </div>
    <div slot="footer" style="text-align:center">
      <el-button size="small" @click="visiable = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getOrderList } from '@/server/after-sales'
export default {
  data() {
    return {
      visiable: false,
      tableData: [],
      loading: false,
      orderNo: '',
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchForm: {
        orderNo: '',
        sourceNo: ''
      },
      columns: [
        {
          prop: 'selection',
          label: '',
          width: 55
        },
        {
          prop: 'orderNo',
          label: this.$t('after-sales::after-sale-list::new_order_num'),
          minWidth: 200
        },
        {
          prop: 'sourceNo',
          label: this.$t('after-sales::after-sale-list::new_shop_order_num'),
          minWidth: 200
        },
        {
          prop: 'payTotalAmount',
          label: this.$t('after-sales::after-sale-list::order_amount'),
          minWidth: 120
        },
        {
          prop: 'refundTotalAmount',
          label: this.$t('after-sales::after-sale-list::all_refund_amount'),
          minWidth: 120
        }
      ],
      configs: [
        {
          label: '',
          key: 'orderNo',
          searchType: 'input',
          componentData: {
            placeHolder: this.$t('after-sales::after-sale-list::new_order_num_holder'),
            clearable: true
          }
        },
        {
          label: '',
          key: 'sourceNo',
          searchType: 'input',
          componentData: {
            placeHolder: this.$t('after-sales::after-sale-list::new_shop_order_num_holder'),
            clearable: true
          }
        }
      ]
    }
  },
  props: {
    value: {}
  },
  methods: {
    async getList() {
      this.loading = true
      const params = { ...this.searchForm, ...this.pagination }
      const { data } = await getOrderList(params)
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.items
        this.pagination.total = data.data.totalCount
      }
    },
    selectRow(row) {
      if (this.orderNo === row.orderNo) this.orderNo = ''
      else this.orderNo = row.orderNo
    },
    submit() {
      if (!this.orderNo) return this.$message.warning(this.$t('after-sales::after-sale-list::new_select_order_tips'))
      this.$emit('changeNo', this.orderNo)
      this.visiable = false
    }
  },
  watch: {
    value(val) {
      this.visiable = val
    },
    visiable(val) {
      this.$emit('input', val)
      if (val) this.getList()
      else this.orderNo = ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
